var map = {
	"./bench.png": 252,
	"./brand.png": 77,
	"./goal-post.png": 253,
	"./lineup.png": 254,
	"./missed.png": 255,
	"./save.png": 256,
	"./scoreboard.png": 115,
	"./substitution.png": 257,
	"./trophy.png": 116,
	"./whistle.png": 117
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 114;